<span
  class="position-relative checkbox-weekdays"
  [ngbTooltip]="tooltip | translate"
  [ngClass]="{ selected: isChecked, 'only-icon': onlyIcon, pointer: !isDisabled }"
  (click)="onValueChange(!isChecked)"
>
  <label
    *ngIf="!icon && name"
    class="m-0"
    [ngClass]="{ 'text-light-gray': !isChecked, pointer: !isDisabled }"
  >
    {{ name | translate }}
  </label>
  <span
    *ngIf="icon"
    [ngClass]="{ 'text-light-gray': !isChecked, pointer: !isDisabled }"
    class="{{ icon }}"
  ></span>
  <i
    *ngIf="!isChecked"
    class="fa-solid fa-xmark text-dark-gray fs-4 position-absolute top-50 start-50 translate-middle"
  ></i>
</span>
